import type { ValidationError } from '../../fieldValidation';
import styles from '../NodeCustomization.module.css';

/**
 * Inline per-field validation message for node customization panels.
 *
 * Renders nothing when `error` is undefined, so callers can pass the result
 * of a `validationErrors.find(...)` lookup directly. Styled to match the
 * error text Ant Design's `Form.Item` shows elsewhere in the app.
 */
export const FieldErrorLabel = ({ error }: { error?: ValidationError }) => {
  if (!error) {
    return null;
  }
  return (
    <div className={`ant-form-item-explain-error ${styles.fieldErrorLabel}`}>
      {error.message}
    </div>
  );
};
